// jwt.js
// HS256 signing via Web Crypto SubtleCrypto with CryptoJS fallback.

function getSubtle() {
  var c = (typeof window !== 'undefined') && (window.crypto || window.msCrypto || window.webkitCrypto);
  return c && (c.subtle || c.webkitSubtle) ? (c.subtle || c.webkitSubtle) : null;
}

function getTextEncoder() {
  if (typeof TextEncoder !== 'undefined') return new TextEncoder();
  // Minimal UTF‑8 encoder fallback
  return {
    encode: function (str) {
      var out = [], p = 0, c, i, u;
      for (i = 0; i < str.length; i++) {
        c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) { out[p++] = (c >> 6) | 192; out[p++] = (c & 63) | 128; }
        else if ((c & 0xFC00) === 0xD800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
          u = 0x10000 + ((c & 0x3FF) << 10) + (str.charCodeAt(++i) & 0x3FF);
          out[p++] = (u >> 18) | 240;
          out[p++] = ((u >> 12) & 63) | 128;
          out[p++] = ((u >> 6) & 63) | 128;
          out[p++] = (u & 63) | 128;
        } else {
          out[p++] = (c >> 12) | 224; out[p++] = ((c >> 6) & 63) | 128; out[p++] = (c & 63) | 128;
        }
      }
      return new Uint8Array(out);
    }
  };
}

function base64UrlEncode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function arrayBufferToBase64Url(buffer) {
  var uint8Array = new Uint8Array(buffer);
  var s = String.fromCharCode.apply(null, uint8Array);
  return base64UrlEncode(s);
}

export function generateUUIDv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function createSignedJWT(payload, secretStr) {
  var header = { alg: 'HS256', typ: 'JWT' };
  var encodedHeader = base64UrlEncode(JSON.stringify(header));
  var encodedPayload = base64UrlEncode(JSON.stringify(payload));
  var signingInput = encodedHeader + '.' + encodedPayload;

  var subtle = getSubtle();
  var encoder = getTextEncoder();

  if (!subtle) {
    if (typeof window !== 'undefined' && window.CryptoJS && window.CryptoJS.HmacSHA256 && window.CryptoJS.enc && window.CryptoJS.enc.Base64) {
      try {
        var sig = window.CryptoJS.HmacSHA256(signingInput, secretStr);
        var b64 = window.CryptoJS.enc.Base64.stringify(sig);
        var b64url = b64.replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
        return Promise.resolve(signingInput + '.' + b64url);
      } catch (e) {
        return Promise.reject(new Error('CryptoJS HMAC failed: ' + e.message));
      }
    }
    return Promise.reject(new Error('WebCrypto SubtleCrypto not available; include CryptoJS HS256 fallback'));
  }

  var keyData = encoder.encode(secretStr);

  return subtle.importKey(
    'raw',
    keyData,
    { name: 'HMAC', hash: { name: 'SHA-256' }, length: 256 },
    false,
    ['sign']
  ).then(function(key) {
    var data = encoder.encode(signingInput);
    return subtle.sign({ name: 'HMAC' }, key, data);
  }).then(function(sig) {
    var encodedSignature = arrayBufferToBase64Url(sig);
    return signingInput + '.' + encodedSignature;
  });
}
